<div>
  <abc-popup
    #userRightsPopup
    fxLayout="column"
    fxLayoutAlign="center center"
    [width]="'70%'"
    [maxWidth]="'700px'"
    [minWidth]="'300px'"
    [height]="'80%'"
    [title]="title"
    [showTitle]="true"
    [showCloseButton]="true"
    (onHiding)="closePopUp()"
    
  >
    <div
      [class.isLoading]="isLoading()"
      fxLayout="column"
      fxLayoutAlign="space-between"
      fxLayoutGap="20px"
      fxFill
      class="custom-popup"
    >
      <div fxFlex="90" class="set-background">
        <abc-scroll-view width="100%" height="100%" [showScrollbar]="true">
          <div class="accordion-container">
            <abc-accordion
              [dataSource]="modules()"
              class="question-accordion"
              [collapsible]="true"
              [multiple]="true"
              [selectedIndex]="[]"
            >
              <div *dxTemplate="let module of 'title'" class="category-header">
                <div class="align-options">
                  <span class="font-bold">{{ res(`Ubt-User-Rights-${module.Context}`) }}</span>
                </div>
              </div>

              <div *dxTemplate="let module of 'item'" class="category-content">
                <!-- Parent Modules -->
                @for (action of actions; track action) {
                  @if(module[action]!=null){
                    <div>
                      <div class="form-group">
                        <div class="label-row">
                          <label>{{ res(`Ubt-User-Rights-${action}`)+' '+res(`Ubt-User-Rights-${module.Context}`)}}:</label>
                          @if(module.isNew){
                          <span class="new-badge">{{res('Ubt-User-Rights-New')}}</span>
                          }
                        </div>
                        <abc-select-box
                          class="selectBox"
                          [(value)]="module[action]"
                          [dataSource]="dataSource"
                          displayExpr="displayText"
                          valueExpr="value"
                          (onValueChanged)="onPermissionChange($event,module, action)"
                        ></abc-select-box>
                      </div>
                    </div>
                  }
                }
                <!-- Child Modules -->
                @for (permission of module?.ChildUserRolePermissions; track permission) {
                  @for (action of actions; track action) {
                    @if(permission[action]!=null){
                      <div>
                        <div class="form-group">
                          <div class="label-row">
                            <label>{{ res(`Ubt-User-Rights-${module.Context}-${permission.Context}-CanView`)}}:</label>
                            @if(permission.isNew){
                            <span class="new-badge">{{res('Ubt-User-Rights-New')}}</span>
                            }
                          </div>
                          <abc-select-box
                            class="selectBox"
                            [(value)]="permission[action]"
                            [dataSource]="dataSource"
                            displayExpr="displayText"
                            valueExpr="value"
                            (onValueChanged)="onPermissionChange($event,permission, action)"
                          ></abc-select-box>
                        </div>
                      </div>
                    }
                  }
                }
              </div>
            </abc-accordion>
          </div>
        </abc-scroll-view>
      </div>
      <div fxFlex="10" fxLayout="row" fxLayoutAlign="end center">
        <abc-button
          class="submit-permession"
          (click)="saveChanges()"
          [text]="res('Ubt-MeasureDetail-Save')"
        >
        </abc-button>
      </div>
        
    </div>
    @if (isLoading()) {
      <ubt-loader></ubt-loader>
    }
  </abc-popup>
</div>
